import { render } from "./404.vue?vue&type=template&id=35459df2&scoped=true"
const script = {}

import "./404.vue?vue&type=style&index=0&id=35459df2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-35459df2"

export default script